<template>
    <div class="right-content">
        <div class="right-content-body">
            <div class="title">
                如何解决温室效应
            </div>
            <div class="content">
                <div class="paragraph">
                    <div v-if="currentPage == 1">
                        <p class="indent">迄今为止，我们无法提出有效的解决对策，但是退而求其次，至少应该想尽办法努力抑制排放量的增长，不可听天由命任凭发展。</p>
                        <p class="indent">首先，暂订2050年作为目标。如果按照目前这种情势发展下去，综合各种温室效应气体的影响，预计地球的平均气温届时将要提升两度以上。一旦气温发生如此大幅提升，地球的气候将会引起重大变化。</p>
                        <p class="indent">因此为今之计，莫过于竭尽所能采取对策，尽量抑制上升的趋势。目前国际舆论也在朝此方向不断进行呼吁，而各国的研究机构亦已提出各种具体的对策方案。</p>
                        <p class="indent">可惜仔细检视各种方案之后，迄今尚未发现任何一项对策足以独挑大梁解决问题。因此，吾人遂有必要寻求一切可能性，全面考量这些对策方案究竟具有何等效果。</p>
                        <p class="bold indent">一、全面禁用氟氯碳化物</p>
                        <p class="indent">实际上全球正在朝此方向推动努力，是以此案最具实现可能性。倘若此案能够实现，对于2050年为止的地球温暖化，根据估计可以发挥3%左右的抑制效果。</p>
                        <p class="bold indent">二、保护森林的对策方案</p>
                        <p class="indent">今日以热带雨林为生的全球森林，正在遭到人为持续不断的急剧破坏。有效的因应对策，便是赶快停止这种毫无节制的森林破坏，另一方面实施大规模的造林工作，努力促进森林再生。目前由于森林破坏而被释放到大气中的二氧化碳，根据估计每年约在1～2gt.碳量左右。倘若各国认真推动节制砍伐与森林再生计划，到了2050年，可能会使整个生物圈每年吸收相当于0.7gt.碳量的二氧化碳。具结果得以降低7%左右的温室效应。</p>
                        <p class="bold indent">三、汽车使用燃料状况的改善</p>
                        <p class="indent">日本汽车在此方面已获技术提升，大幅改善昔日那种耗油状况。但在美国等地，或许是因油藏丰富，对于省油设计方面，至今未见有何明显改善迹象，仍旧维持过度耗油的状况。因此，该地区生产的汽车在改善燃油设计方面，具有充分发挥的余地。由于此项努力所导致的化石燃料消费削减，估计到了2050年，可使温室效应降低5%左右。</p>
                        <p class="bold indent">四、改善其他各种场合的能源使用效率</p>
                        <p class="indent">是要改善其他各种场合的能源使用效率。今日人类生活，到处都在大量使用能源，其中尤以住宅和办公室的冷暖气设备为最。因此，对于提升能源使用效率方面，仍然具有大幅改善余地，这对2050年为止的地球温暖化，预计可以达到8%左右的抑制效果。</p>
                        <p class="bold indent">五、对化石燃料的生产与消费，依比例课税</p>
                    </div>
                    <div v-if="currentPage == 2">
                        <p class="indent">如此一来，或许可以促使生产厂商及消费者在使用能源时有所警惕，避免作出无谓的浪费。而其税金收入，则可用于森林保护和替代能源的开发方面。</p>
                        <p class="indent">任何化石燃料一经燃烧，就会排放出二氧化碳来。惟其排放量会因化石燃料种类而有不同。由于天然瓦斯的主要成分为甲烷，故其二氧化碳排放量要比煤炭、石油为低。同样是要产生一千卡的热量，煤炭必须排放相当于0.098公克碳量的二氧化碳；这在石油则为0.085公克；若是换成天然瓦斯只需排放0.056公克即可。</p>
                        <p class="indent">因此，有人提案依照天然瓦斯、石油、煤炭的顺序予以加重课税。譬如生产方面，要对二氧化碳排放量较高的煤炭，以能量换算，每十亿焦耳课税0.5美元，而对天然瓦斯则只课税0.23美元。亦即二氧化碳排放量愈高的化石燃料课税愈重。至于消费方面的情形亦复加此，其课税比例在煤炭订为23%，在天然瓦斯订为13%。</p>
                        <p class="indent">当然，现今阶段只不过是有这么一个构想而已。但若果真付诸实行，可望对于2050年为止的地球温暖化，提供大约5%的抑制效果。</p>
                        <p class="bold indent">六、鼓励使用天然瓦斯作为当前的主要能源</p>
                        <p class="indent">因为天然瓦斯较少排放二氧化碳。最近日本都市也都普遍改用天然瓦斯取代液化瓦斯，此案则是希望更进一步推广这种运动。惟其抑制温暖化的效果并不太大，顶多只有1%的程度左右。</p>
                        <p class="bold indent">七、汽机车的排气限制</p>
                        <p class="indent">由于汽机车的排气中，含有大量的氮氧化物与一氧化碳，因此希望减少其排放量。这种作法虽然无法达到直接削减二氧化碳的目的，但却能够产生抑制臭氧和甲烷等其他温室效应气体的效果。预计将对2050年为止的温暖化，分担2%左右的抑制效果。</p>
                        <p class="bold indent">八、鼓励使用太阳能</p>
                        <p class="indent">譬如推动所谓“阳光计划”之类。这方面的努力能使化石燃料用量相对减少，因此对于降低温室效应具备直接效果。不过，就算积极推动此项方案，对于2050年为止的温暖化，只具4%左右的抑制效果。其效果似乎未如人们的期待。</p>
                        <p class="bold indent">九、开发替代能源</p>
                        <p class="indent">利用生物能源(Biomass Energy)作为新的干净能源。亦即利用植物经由光合作用制造出来的有机物充当燃料，藉以取代石油等既有的高污染性能源。</p>
                    </div>
                </div>
                <div class="link-content">
                    <div class="bottom">
                        <img src="../../assets/images/wenben.jpg" />
                        <span style="margin-left: 30px">页码: </span> <span :class="{ active: currentPage == 1 }" class="page" @click="currentPage = 1">1</span> - <span :class="{ active: currentPage == 2 }" class="page" @click="currentPage = 2">2</span>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "SoluteGreenhouseView",
        data() {
            return {
                currentPage: 1
            }
        },
        methods: {
            onIndexChanged(retIndex) {
                this.index = retIndex
            }
        }
    }
</script>

<style lang="scss" scoped>
    .right-content {
        padding: 30px;
        margin-left: 130px;
        font-size: 13px;
        .right-content-body {
            max-height: 620px;
            overflow-y: auto;
            overflow-x: hidden;
            .title {
                -webkit-text-stroke: 0.05em #33c;
                -webkit-text-fill-color : transparent;
                font-size: 30px;
                text-shadow: 3px 3px 2px #b2b2b2;
                text-align: left;
                font-family: SimSun;
            }
            .content {
                margin-top: 40px;
            }
            p {
                line-height: 12px;
            }

        }
    }
    .link-content {
        margin-top: 2%;
        margin-left: 10%;
        width: 80%;
        text-align: center;
        .bottom {
            float: left;
            width: 100%;
            height: 80px;
            img {
                width: 50px;
                height: 50px;
            }
            .margin-left {
                margin-left: 40%;
            }
            a, span {
                font-size: 15px;
                color: #008000;
                text-decoration: none;
                cursor: pointer;
            }
            .page {
                padding: 3px 8px;
                border: 1px #aaa solid;
                background: #eee;
                box-shadow: -1px -1px 2px #ccc inset;
                font-weight: bold;
                &.active {
                    background: #4a97d4;
                    border: 1px #175187 solid;
                    color: #fff;
                    box-shadow: -1px -1px 2px #7894bd inset;
                }
            }
        }

    }
</style>